import { useApi } from '@/api';
import { CardList, LinkButton, ListSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CurrencyValue,
  Flex,
  ListItem,
  WalletAddress
} from '@blockanalitica/ui';
import { Link } from 'react-router-dom';

export default function TopWallets({ ...rest }) {
  const [data, error] = useApi({
    url: '/upgrade/usds/wallets/',
    queryParams: {
      p_size: '3',
      order: '-balance'
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <CardList
        title="Top Wallets"
        action={
          <LinkButton to="wallets" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.wallet_address}
              to={`wallets/${row.wallet_address}`}>
              <Flex justifyContent="space-between" alignItems="center">
                <WalletAddress
                  address={row.wallet_address}
                  options={{ name: row.wallet_name }}
                />
                <CurrencyValue
                  value={row.balance}
                  options={{
                    currency: tokensMapping('USDS'),
                    iconSize: '-1'
                  }}
                />
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
